import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CANCEL_UPLOAD_CONFIRM_CALL_CONTEXT } from '@/modules/uploaderNew/constants';

import { cancelImpersonationAction } from '@/modules/@common/token/redux/slices';
import { getUserFirstNameSelector } from '@/modules/@common/user/redux/selectors';

import ViewportDraggable from '@/modules/@common/ViewportDraggable/ViewportDraggable';
import useShowCancelUploadDialog from '@/modules/uploaderNew/components/useShowCancelUploadDialog';
import {
  Button, Paper, Stack,
  Typography,
} from '@/mui/components';

import styles from './styles.module.scss';

function Impersonate() {
  const dispatch = useDispatch();
  const { hasInProgress, handleOpenConfirmDialog } = useShowCancelUploadDialog();

  const userFirstName = useSelector(getUserFirstNameSelector);

  return (
    <ViewportDraggable className={styles.Wrapper}>
      <Paper elevation={3} className={styles.Container}>
        <Stack spacing={0}>
          <Typography variant="body2" color="text.primary">
            You are currently logged in as
          </Typography>
          <Typography variant="body2" color="text.primary">
            {userFirstName}
          </Typography>
        </Stack>
        <Button
          variant="outlined"
          color="primary"
          className={styles.Button}
          onClick={() => {
            if (hasInProgress) {
              handleOpenConfirmDialog(CANCEL_UPLOAD_CONFIRM_CALL_CONTEXT.fromLoginAs);
            } else {
              dispatch(cancelImpersonationAction());
            }
          }}
        >
          Switch back
        </Button>
      </Paper>
    </ViewportDraggable>
  );
}

export default Impersonate;
